import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from 'yup'
import axiosMain from "../axiosMain";
import ToastNotification from "./Toast/ToastNotification";
import Divider from '@mui/material/Divider';
import { BASE_URLS } from "../utils/baseUrls";

const ResetPasswordWithEmail = ({ emailList, showmulEmailModal, setShowmulEmailModal, apiResponse, phoneNo }) => {

    const [selectedEmail, setSelectedEmail] = useState(null);
    const [mulemailMessage, setmulemailMessage] = useState("");
    const [showPasswordModal, setShowPasswordModal] = useState(false);

    const handleRadioChange = (emailId) => {
        setSelectedEmail(emailId);
        if (emailId != null || emailId != "") {
            setmulemailMessage("");
        }
    };


    const handleSubmit = () => {
        if (!selectedEmail) {
            setmulemailMessage("Please select an email.");
            return;
        }
        setShowmulEmailModal(false);
        setShowPasswordModal(true);
    };
    //password change
    const passwordFormik = useFormik({
        initialValues: {
            password: "",
            confirmPassword: "",
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .min(6, "Password must be at least 6 characters")
                .required("Password is required"),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref("password"), null], "Passwords must match")
                .required("Confirm Password is required"),
        }),
        onSubmit: (values) => {
            axiosMain.post(BASE_URLS + "/Registration/UserChangePassword", {
                // DomainUrl: "https://beta.tendergpt.io",
                UserId: selectedEmail?.userId,
                MobileNo: phoneNo,
                EmailId: selectedEmail?.userEmailId,
                CurrentPassword: "",
                Newpassword: values.password,
                ConfirmPassword: values.confirmPassword,
                // UserDetailId: apiResponse?.UserDetailId
                UserDetailId: 0,
            })
                .then((res) => {
                    console.log(res, "userpassword");
                    if (res?.data === 1) {
                        ToastNotification.success("Password Change Successfully Log in Now !")
                    }
                    else {
                        ToastNotification.warning("Something not match !");
                    }
                    setShowPasswordModal(false);
                    setShowmulEmailModal(false);
                    passwordFormik.resetForm();
                })
                .catch((exx) => {
                    ToastNotification.error("Unable to change Password try agian latter")
                })

        },
    });

    return (
        <>




            {/*rest mult email Modal */}
            {/* <Modal show={showmulEmailModal} onHide={() => setShowmulEmailModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Select Email ID to change Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <ul>
                            {emailList.map((email) => (
                                <li key={email.userId}>
                                    <input
                                        type="radio"
                                        name="email"
                                        value={email.userEmailId}
                                        onChange={() => handleRadioChange(email)}
                                    />
                                    {email.userEmailId}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="text-danger">{mulemailMessage}</div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => handleSubmit()} disabled={!selectedEmail}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal> */}
            <Modal show={showmulEmailModal} onHide={() => setShowmulEmailModal(false)} size="md" centered>
                <Modal.Header>
                    <Button onClick={() => {
                        setShowmulEmailModal(false);
                    }} className="modal-btn-close"><i className="fa fa-close"></i></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="LoginApp">
                        <div className="modal-bx-filed-set modal-bx-filed-set-reset-pass-form ">
                            <fieldset>
                                <legend>Select Email ID to change Password</legend>


                                <div className="reset-pass-form">

                                    <ul>
                                        {emailList.map((email) => (
                                            <>
                                                <li key={email.userId}>
                                                    <input
                                                        type="radio"
                                                        name="email"
                                                        value={email.userEmailId}
                                                        onChange={() => handleRadioChange(email)}
                                                    />
                                                    {email.userEmailId}
                                                </li>
                                                < Divider />
                                            </>
                                        ))}
                                    </ul>
                                    <ul>

                                        {/* <li key={1}>
                                            <input
                                                type="radio"
                                                name="email"
                                                value={1}

                                            />
                                            Samar Das
                                        </li>
                                        < Divider />
                                        <li key={2}>
                                            <input
                                                type="radio"
                                                name="email"
                                                value={2}

                                            />
                                            sxsdsd
                                        </li> */}

                                    </ul>
                                    <div className="text-danger">{mulemailMessage}</div>
                                    <Button onClick={() => handleSubmit()} disabled={!selectedEmail}>
                                        Submit
                                    </Button>
                                </div>

                            </fieldset>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
            {/* reset with password and confpassword */}
            {/* <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Change Password</Modal.Title>
                    <p>EMail Id: {selectedEmail?.userEmailId}</p>
                    <p>phone No: {phoneNo}</p>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={passwordFormik.handleSubmit}>
                     
                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                name="password"
                                placeholder="Enter password"
                                value={passwordFormik.values.password}
                                onChange={passwordFormik.handleChange}
                                onBlur={passwordFormik.handleBlur}
                                isInvalid={
                                    passwordFormik.touched.password && passwordFormik.errors.password
                                }
                            />
                            <Form.Control.Feedback type="invalid">
                                {passwordFormik.errors.password}
                            </Form.Control.Feedback>
                        </Form.Group>

                       
                        <Form.Group className="mb-3">
                            <Form.Label>Confirm Password</Form.Label>
                            <Form.Control
                                type="password"
                                name="confirmPassword"
                                placeholder="Confirm password"
                                value={passwordFormik.values.confirmPassword}
                                onChange={passwordFormik.handleChange}
                                onBlur={passwordFormik.handleBlur}
                                isInvalid={
                                    passwordFormik.touched.confirmPassword &&
                                    passwordFormik.errors.confirmPassword
                                }
                            />
                            <Form.Control.Feedback type="invalid">
                                {passwordFormik.errors.confirmPassword}
                            </Form.Control.Feedback>
                        </Form.Group>

                        
                        <Button variant="primary" type="submit">
                            Update Password
                        </Button>
                    </Form>
                </Modal.Body>
                
            </Modal> */}
            <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)} centered size="md">
                <Modal.Header >
                    <Button onClick={() => setShowPasswordModal(false)} className="modal-btn-close">
                        <i className="fa fa-close"></i>
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-bx-filed-set generate-new-password-model">
                        <fieldset>
                            <legend>Generate New Password</legend>
                            <Form onSubmit={passwordFormik.handleSubmit} className="generate-new-password">
                                {/* Password field */}
                                <p>Mobile Number: {phoneNo}</p>
                                <p>Email Id: {selectedEmail?.userEmailId}</p>

                                <Form.Group className="mb-1">

                                    <Form.Control
                                        type="password"
                                        name="password"
                                        placeholder="Enter New password"
                                        value={passwordFormik.values.password}
                                        onChange={passwordFormik.handleChange}
                                        onBlur={passwordFormik.handleBlur}
                                        isInvalid={
                                            passwordFormik.touched.password && passwordFormik.errors.password
                                        }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {passwordFormik.errors.password}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                {/* Confirm Password field */}
                                <Form.Group className="mb-1">

                                    <Form.Control
                                        type="password"
                                        name="confirmPassword"
                                        placeholder="Enter Confirm Password"
                                        value={passwordFormik.values.confirmPassword}
                                        onChange={passwordFormik.handleChange}
                                        onBlur={passwordFormik.handleBlur}
                                        isInvalid={
                                            passwordFormik.touched.confirmPassword &&
                                            passwordFormik.errors.confirmPassword
                                        }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {passwordFormik.errors.confirmPassword}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                {/* Submit button */}
                                <Button size="sm" type="submit">
                                    Update Password
                                </Button>
                            </Form>
                        </fieldset>
                    </div>
                </Modal.Body>
                {/* <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowPasswordModal(false)}>
                        Close
                    </Button>
                </Modal.Footer> */}
            </Modal>
        </>
    );
};

export default ResetPasswordWithEmail;
